<!-- Sidebar Navigation end-->
<div class="page-content">
  <!-- Page Header-->
  <div class="page-header no-margin-bottom">
    <div class="container-fluid">
      <h2 class="h5 no-margin-bottom">heyPogi Account Tiers</h2>
    </div>
  </div>

  <section class="pt-20">
    <div *ngIf="subscription$ | async">
      <ng-container *ngIf="step === 1">
        <div class="page-header payment-header">
          <h1 align="center">Get Yout Premium Access Now! <br /></h1>
        </div>
        <div align="center">
          <!-- PayPal disabled since Dec 1, 2021. Restore only with a supported modern PayPal SDK. -->
          <button
            class="btn btn-primary payment-btn"
            (click)="selectPaymentMethod('patreon')"
            [disabled]="paymentLoading || (loading$ | async)"
          >
            Pay with Credit Card via Patreon Membership</button
          ><br />
          <button
            class="btn btn-primary payment-btn"
            (click)="selectPaymentMethod('other')"
            [disabled]="(loading$ | async) || paymentLoading"
          >
            Pay with GCash, Maya or PHL Bank Account Transfer
          </button>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="step === 2">
      <div class="page-header payment-header">
        <h1 align="center" style="font-size: 1.5rem">
          Plan 30 Days - PHP 499
          <span
            style="display: block;
       font-size: 12px;
       color: #fff;
       font-weight: 400;"
            >Automatic Expiration</span
          >
        </h1>
        <h1 align="center" style="font-size: 1.5rem">
          Plan 90 Days - PHP 999
          <span
            style="display: block;
       font-size: 12px;
       color: #fff;
       font-weight: 400;"
            >Best Value at PHP 333/month. Automatic Expiration</span
          >
        </h1>
      </div>
      <div align="center">
        <div style="display: flex; gap: 2em;  justify-content: center; width: 300px;margin-bottom: 20px;">
          <div style="flex: 1 30%">
            <img src="assets/images/gcash.png" width="100%" style="border: 5px solid #fff" />
          </div>
          <div style="flex: 1 70%">
            <h3 align="center" style="color: #fff;font-size: 15px; padding-top: 5px">
              Send Payment to: <br />0920 951 1161
            </h3>
            <span style=" font-size: 12px">Account: Carlos Gilbert Barrera</span>
          </div>
        </div>
        <div style="display: flex; gap: 2em;  justify-content: center; width: 300px;margin-bottom: 20px;">
          <div style="flex: 1 30%">
            <img src="assets/images/Maya.png" width="100%" style="border: 5px solid #fff" />
          </div>
          <div style="flex: 1 70%">
            <h3 align="center" style="color: #fff;font-size: 15px; padding-top: 5px">
              Send Payment to: <br />
              0920 951 1161
            </h3>
            <span style=" font-size: 12px">Account: Carlos Gilbert Barrera</span>
          </div>
        </div>
        <div style="display: flex; gap: 2em;  justify-content: center; width: 300px;margin-bottom: 20px;">
          <div style="flex: 1 30%">
            <img src="assets/images/bpi.jpeg" width="100%" style="border: 5px solid #fff" />
          </div>
          <div style="flex: 1 70%">
            <h3 align="center" style="color: #fff;font-size: 15px; padding-top: 5px">
              BPI Account Number: <br />
              4279203343
            </h3>
            <span style=" font-size: 12px">Account: Carlos Gilbert Barrera</span>
          </div>
        </div>
        <br />
        <br />
        <h1 align="center">
          <span
            style="display: block;
       font-size: 16px;
       color: #fff;
       font-weight: 400;"
            >Email your transaction screenshot to <a href="mailto: ">support@heypogi.com</a></span
          >
          <span
            style="display: block;
       font-size: 16px;
       color: #fff;
       font-weight: 400;"
            >Within 24 hours, you will receive an email once your Premium Access is activated.</span
          >
        </h1>
      </div>
    </ng-container>
    <ng-container *ngIf="step === 3">
      <div class="page-header payment-header">
        <h1 align="center">
          To pay using GCash, Paymaya or BPI
        </h1>
      </div>
      <div
        align="center"
        style="font-size: 30px;
      line-height: 1.2;
      margin-bottom: 30px;color:white"
      >
        Please check your email.<br />
        Instructions have been sent<br />
        On how to transfer your payment.
      </div>
    </ng-container>

    <!-- For Patreon  -->
    <ng-container *ngIf="step === 4">
      <div class="page-header payment-header">
        <h1 align="center">
          Paying with Credit Card
          <span
            style="display: block;
          font-size: 16px;
          color: #fff;
          font-weight: 400;"
            >USD 9 per month, Cancel Anytime (around PHP 500)</span
          >
        </h1>
      </div>
      <div
        align="center"
        style="font-size: 30px;
      line-height: 1.2;
      margin-bottom: 30px;color:white"
      >
        1. Subscribe to our Patreon Account
        <a href="https://www.patreon.com/heypogi" target="_blank">www.patreon.com/heypogi</a><br />
        2. Select <strong>Patreon Plus</strong> Membership<br />
        3. Within 24 hours, you will receive an email once your Premium Access is activated.
      </div>
    </ng-container>

    <div align="center"><img src="assets/images/logo1.png" width="170px" /></div>

    <div align="center" *ngIf="loading$ | async" class="payment-loading">
      <i class="fa fa-circle-o-notch fa-spin fa-lg fa-fw"></i><br />
      Loading
    </div>
  </section>
</div>
